import API from '../..';
const ENTITY = 'segments';

export const patchGroup = (segmentUUID, data) =>
    API.patch(`/api/v1/${ENTITY}/${segmentUUID}/groups/`, data, {
        headers: { 'Content-Type': 'application/json' },
    });
